import gsap from "gsap";
import { SplitText } from "gsap/SplitText";

// core version + navigation, pagination modules:
import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css/autoplay';		

gsap.registerPlugin(SplitText);


function splitBannerText() {
  var split = new SplitText(".split-title", { type: "lines", position: "relative", tag: "div", linesClass: "!inline-block" });

  $('.split-title div:last-of-type').addClass('underline-highlight-130');
}

function bannerSlider() {
  const imgSlider = new Swiper('.js-banner-slider', {
    modules: [Pagination, Autoplay],
    loop: true,
    draggable: true,
    allowTouchMove: true,
    autoplay: {
      delay: 2800,
      pauseOnMouseEnter: true,
    },
    speed: 550,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
bannerSlider();


function bannerAnimation() {
  bannerSlider()
  splitBannerText()
}

export default bannerAnimation;